module.exports = __webpack_public_path__ + "static/media/hero1.15325a40.jpeg";